import { Css } from "@homebound/beam";

export function TextHeader(props: { text: string }) {
  const { text } = props;
  return <div css={Css.sm.$}>{text}</div>;
}
